import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * The XP message box, shipped as an ordinary app so *anything* can raise one
 * with `wm.open('msgbox', { … })` — no modal machinery, no global singleton,
 * no special case in the window manager.
 *
 * Args:
 *   title    string                                       window caption
 *   text     string (may contain `\n`)                    the message
 *   icon     'error' | 'info' | 'warning' | 'question'    default 'info'
 *   buttons  string[]                                     default ['OK']
 *   detail   string                                       optional small print
 *   onResult (button: string) => void                     optional callback
 */
export const msgboxApp: AppManifest = {
  id: 'msgbox',
  name: 'Windows',
  icon: '/assets/icons/msg-info.svg',
  component: lazy(() => import('./MsgBox')),

  defaultSize: { w: 400, h: 165 },
  resizable: false,
  maximizable: false,
  singleton: false,
  dialog: true,
  showInAllPrograms: false,

  titleFor: (args) => String(args.title ?? 'Windows'),
};
